if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

    $(document).ready(function(){
    $('.delivery_tab').on('click', function(){
      $(".delivery_tab").css("color", "#01425f");
       $('.login_tab').css("color", "#d0c8b1"),
      $('.page_delivery').show();
      $('.login_custom').hide();
       $('.cart__ctas').hide();
       $('.not-empty').hide();
       $('.drawer__inner-empty').hide();
    })
    $('.login_tab').on('click', function(){
      $('.login_tab').css("color", "#01425f"),
        $(".delivery_tab").css("color", "#d0c8b1");
      $('.login_custom').show();
      $('.page_delivery').hide();
        $('.cart__ctas').hide();
       $('.not-empty').hide();
      $('.drawer__inner-empty').hide();
    })
    $('.cart_tab').on('click', function(){
      $(".delivery_tab").css("color", "#d0c8b1");
       $('.login_tab').css("color", "#d0c8b1"),
       $('.drawer__inner-empty').show();
       $('.not-empty').show();
      $('.login_custom').hide();
        $('.cart__ctas').show();
       $('.page_delivery').hide();
    })
    
    $('.tabs-nav a').on('click', function(){
            // Check for active
            $('.tabs-nav li').removeClass('actives');
            $(this).parent().addClass('actives');
            // Display active tab
            let currentTab = $(this).attr('href');
            $('.tabs_no').hide();
            $(currentTab).show();
            return false;
          })   

    
  })
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      if(this.querySelector('.loading-overlay__spinner')){ this.querySelector('.loading-overlay__spinner').classList.remove('hidden'); }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }

  if(document.querySelector('[name="giftWrapProduct"]') &&document.querySelector('[name="giftWrapProduct"]').checked) {
  for (var pair of formData.entries()) {
  if(pair[0] =='id') var mainID= pair[1];
  if(pair[0] =='quantity') var mainQuantity= pair[1];   
  }
   
  let formDataNew = {
 'items': [{
  'id': document.querySelector('[name="giftWrapProduct"]').value,
  'quantity': 1
  },
  {
  'id': mainID,
  'quantity': mainQuantity
  },         
  ]
};
 
    var formData1 = new FormData();
// Loop through the items in formDataNew and append them to the FormData object
  formDataNew.items.forEach(function(item, index) {
   var mainID= item.id;
  formData1.append(`items[${index}][id]`, item.id);
  formData1.append(`items[${index}][quantity]`, item.quantity);
});

     formData1.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
     formData1.append('sections_url', window.location.pathname);
     config.body = formData1;
    }

else if(document.querySelector('[name="add_sleeve"]') && document.querySelector('[name="add_sleeve"]:checked')){
       const checkedCheckbox = document.querySelector('[name="add_sleeve"]:checked')
  //console.log("SSSSS",checkedCheckbox.dataset)
  for (var pair of formData.entries()) {
  if(pair[0] =='id') var mainID= pair[1];
  if(pair[0] =='quantity') var mainQuantity= pair[1];   
  }
   
let formDataNew = {
  'items': [
    {
      'id': checkedCheckbox.value,
      'quantity': mainQuantity,
      'properties': {
        "_Main_product": checkedCheckbox.dataset.property1,
        "_Main_variant_id":mainID
      }
    },
    {
      'id': mainID,
      'quantity': mainQuantity,
      'properties': {
        "Sleeve_product": checkedCheckbox.dataset.property2,
        "_Sleeve_variant_id":checkedCheckbox.dataset.variant2
      }
    }
  ]
};

var formData1 = new FormData();

// Loop through the items in formDataNew and append them to the FormData object
formDataNew.items.forEach(function(item, index) {
  formData1.append(`items[${index}][id]`, item.id);
  formData1.append(`items[${index}][quantity]`, item.quantity);

  // Convert the properties object to a JSON string before appending
  Object.keys(item.properties).forEach((key) => {
    formData1.append(`items[${index}][properties][${key}]`, item.properties[key]);
  });
});

// Check the values appended to the FormData
for (let pair of formData1.entries()) {
  console.log(pair[0], pair[1]);
}


     formData1.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
     formData1.append('sections_url', window.location.pathname);
     config.body = formData1;
  
}
    else { 
      config.body = formData;
      }
 //return false;
      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => { console.log(response)
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {  console.log(response)
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
           if(this.querySelector('.loading-overlay__spinner')){this.querySelector('.loading-overlay__spinner').classList.add('hidden');}
        });      
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
